import React from 'react'
import { useTranslation } from 'react-i18next'

import { groupAllLabelI18nKey, type GroupAndAll } from '~/utils'

import { useAtomValueContext } from '../providers/AtomsProvider'

export const useGroupAndAllNameMap = () => {
  const { t } = useTranslation()
  const groupNameMap = useAtomValueContext('groupNameMap')

  return React.useMemo<Record<GroupAndAll, string>>(
    () => ({
      all: t(groupAllLabelI18nKey),
      ...groupNameMap,
    }),
    [groupNameMap, t],
  )
}
